import React from "react";

export interface VerifyAgeContextValue {
  verifyAge: (callback: (success: boolean) => void, style?: VerifyStyle) => void;
}

export const enum VerifyStyle {
  DATA_HANDLING = 0,
  HURDLE = 1,
}

export const VerifyAgeContext = React.createContext<VerifyAgeContextValue>(
  null!
);
